import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Feature } from '../feature'

/**
 * Triggers the schema loading process when there are changes to the zone context.
 */
export const triggerSchemaLoading = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    meFeature.contexts.selectors.zoneContext.asObservable.pipe(
      rxjs.switchMap(context =>
        context
          ? rxjs.of(
              feature.actions.loadSchema
                .from('triggerSchemaLoading (effect)')
                .create({ context }),
            )
          : rxjs.EMPTY,
      ),
    ),
)
